import { createGlobalStyle } from 'styled-components';
import { rem, theme } from '@/styles/theme';
import { normalize } from 'styled-normalize';
import { reset } from 'styled-reset';

// root font size를 조절해서 폴드화면 대응가능??
// font-size: 10px;
// ${({ theme }) => theme.media.mobile`
//   font-size: 16px;
// `}

const GlobalStyle = createGlobalStyle`
  @font-face {
    font-family: 'Galmuri14';
    src: url('https://cdn.jsdelivr.net/gh/projectnoonnu/2506-1@1.0/Galmuri14.woff2') format('woff2');
    font-weight: normal;
    font-display: swap;
  }

  ${reset};
  ${normalize};
  html {
    -ms-text-size-adjust: 100%;
    -webkit-text-size-adjust: 100%;
  }

  abbr, blockquote, body, button, dd, dl, dt, fieldset, figure, form, h1, h2, h3, h4, h5, h6, hgroup, input, legend, li, ol, p, pre, ul, hr {
    margin: 0;
    padding: 0
  }

  address, caption, code, figcaption, pre, th {
    font-size: 1rem;
    font-weight: 400;
    font-style: normal;
  }

  fieldset, iframe {
    border: 0;
  }

  caption, th {
    text-align: left;
  }

  table {
    border-collapse: collapse;
    border-spacing: 0;
  }

  details, main, summary {
    display: block;
  }

  audio, canvas, progress, video {
    vertical-align: initial;
  }

  button {
    background: none;
    border: 0;
    box-sizing: initial;
    color: inherit;
    //cursor: pointer;
    //font: inherit;
    //font-family: 'Noto Sans KR', sans-serif;
    font-family: 'Pretendard Variable', 'sans-serif';
    line-height: inherit;
    overflow: visible;
    vertical-align: inherit;
  }

  button:disabled {
    cursor: default;
  }

  :focus[data-focus-method=mouse]:not(input):not(textarea):not(select), :focus[data-focus-method=touch]:not(input):not(textarea):not(select) {
    outline: none;
  }

  ::-moz-focus-inner {
    border: 0;
    padding: 0;
  }
  a {
    text-decoration: none;
  }

  body {
    margin: 0;
    padding: 0;
    font-family: 'Pretendard Variable', 'sans-serif';
    overflow-x: hidden;
    &::-webkit-scrollbar-track {
      background-color: transparent;
    }

    &::-webkit-scrollbar {
      display: none;
      height: 0;
      background-color: transparent;

    }
  // swiper css
  .swiper-pagination {
    width: 100%;
    display: flex;
    gap: ${rem(8)};
    justify-content: center;
    align-items: center;
    margin-top: ${rem(26)};

    &-bullet {
      width: ${rem(8)};
      height: ${rem(8)};
      border-radius: 100%;
      background: ${theme.color['gray-300']};
      transition: all 0.3s ease-in-out;
      &-active {
        width: ${rem(18)};
        border-radius: ${rem(100)};
        background: ${theme.color['primary-100']};
        transition: all 0.3s ease-in-out;
      }
    }
  }
}
`;

export default GlobalStyle;
